<div
  [attr.data-theme]="theme()"
  [attr.data-border]="border()">
  <ng-content select="app-accordion-item"></ng-content>
</div>
